import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

class EditProfile extends Component {
  render() {
    return (
      <Container>
        <form>
          <Link to="AdminSys">back</Link>
          <h1 id="label1">Edit profile</h1>
          <input type="text" id="inputText" placeholder="JOHN" />
          <input type="text" id="inputText" placeholder="DOE" />
          <Button variant="success" id="addOffice">
            save
          </Button>
          <Button variant="outline-danger" id="addOffice">
            cancel
          </Button>

          <input type="text" id="inputText" placeholder="Current Password" />
          <input type="text" id="inputText" placeholder="New Password" />
          <input type="text" id="inputText" placeholder="Confirm Password" />
          <Button variant="success" id="addOffice">
            save
          </Button>
          <Button variant="outline-danger" id="addOffice">
            cancel
          </Button>
        </form>
      </Container>
    );
  }
}

export default EditProfile;
